import { createActions } from '../utils/actions';

const { actions: mediaLibrary } = createActions('studio.photo')
  .add('bootstrap')
  .add('cleanUp')
  .addAsync('createFolder')
  .addAsync('deleteFolder')
  .addAsync('deleteItems')
  .addAsync('downloadItems')
  .add('editImages')
  .addAsync('getFolders')
  .addAsync('getItems')
  .addAsync('moveItems')
  .addAsync('renameFolder')
  .addAsync('saveImage')
  .add('setValue')
  .add('toggleImageState')
  .addAsync('updateImage')
  .addAsync('uploadFiles');

export default mediaLibrary;
